var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", { attrs: { fill: "currentColor", "fill-rule": "nonzero" } }, [
    _c("path", {
      attrs: {
        d: "M28.5 57c3.934 0 7.635-.742 11.105-2.227 3.47-1.484 6.494-3.516 9.073-6.095 2.58-2.579 4.611-5.603 6.095-9.073C56.258 36.135 57 32.434 57 28.5s-.742-7.635-2.227-11.105c-1.484-3.47-3.516-6.494-6.095-9.073-2.579-2.58-5.603-4.611-9.073-6.095C36.135.742 32.434 0 28.5 0s-7.635.742-11.105 2.227c-3.47 1.484-6.494 3.516-9.073 6.095-2.58 2.579-4.611 5.603-6.095 9.073C.742 20.865 0 24.566 0 28.5s.742 7.635 2.227 11.105c1.484 3.47 3.516 6.494 6.095 9.073 2.579 2.58 5.603 4.611 9.073 6.095C20.865 56.258 24.566 57 28.5 57zm0-3c-3.529 0-6.84-.673-9.932-2.018-3.093-1.346-5.787-3.175-8.083-5.487-2.296-2.312-4.117-5.013-5.464-8.102C3.674 35.303 3 31.997 3 28.472c0-3.526.674-6.833 2.02-9.922 1.348-3.089 3.17-5.78 5.465-8.073 2.296-2.294 4.99-4.113 8.083-5.459C21.66 3.673 24.97 3 28.5 3c3.529 0 6.84.673 9.932 2.018 3.093 1.346 5.787 3.165 8.083 5.459 2.296 2.293 4.117 4.984 5.464 8.073C53.326 21.64 54 24.946 54 28.472c0 3.525-.674 6.832-2.02 9.921-1.348 3.09-3.17 5.79-5.465 8.102-2.296 2.312-4.99 4.141-8.083 5.487C35.34 53.327 32.03 54 28.5 54z",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M31.5 33L33 12h-9l1.5 21h6zm-3 12c1.281 0 2.352-.393 3.21-1.178.86-.785 1.29-1.74 1.29-2.866 0-1.126-.422-2.067-1.266-2.823C30.891 37.378 29.812 37 28.5 37c-1.313 0-2.39.378-3.234 1.133C24.422 38.89 24 39.83 24 40.956c0 1.125.43 2.081 1.29 2.866.858.785 1.929 1.178 3.21 1.178z",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }